{
  "nav": {
    "mainNavigation": "Main navigation",
    "sectionSettings": "Settings",
    "settings": "Settings",
    "tiers": "Commission tiers",
    "transferSettings": "Transfer settings",
    "users": "Users",
    "groups": "Groups",
    "transfers": "Transfers",
    "boxes": "Boxes",
    "bankAccounts": "Bank accounts",
    "reports": "Reports",
    "changeBranch": "Change Branch",
    "systems": "Systems",
    "toggleSidebarHint": "Toggle navigation",
    "newTransfer": "New transfer",
    "transferDrafts": "Draft transfers"
  },
  "sidebar": {
    "toggle": "Toggle sidebar",
    "toggleHint": "Show or hide the menu",
    "title": "Sidebar",
    "description": "Navigate between the system pages"
  },
  "brand": "Al-Musafer"
}
